// REQUEST & RESPONSE TYPES

export type GetPreviousBillingCyclePeriodsResponseData = {
  periods?: PreviousBillingCyclePeriod[]
}

export type SettlementDefaultProps = {
  startDate: string // ISO
  endDate: string // ISO
}

export type PreviousBillingCyclePeriod = {
  id: string
  fuel?: {
    electricity: boolean
    gas: boolean
  }
} & SettlementDefaultProps

// ENUMS

export enum TransfoErrorCodes {
  E304_CONTRACT_TOO_YOUNG = 'E304',
  E311_NO_DATA_AVAILABLE_FOR_FUTURE_DATES = 'E311',
  E431_NO_INVOICE_FOUND = 'E431',
  E442_NEAR_METERREADING_MONTH = 'E442',
  E443_NO_FUTURE_INSTALMENTS = 'E443',
  E444_MISSING_DECENTRALIZED_PRODUCTION = 'E444',
  E454_MISSING_SERVICE_DELIVERIES = 'E454',
  E456_DELIVERY_OUT_OF_SCOPE = 'E456',
  E547_DEFAULT_VALUES_IN_BILLSHOCK = 'E547'
}
